import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettlement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.51719 4.66154L1 5.95385L4.51719 7.53333L5.92406 11.2667L7.47162 7.53333L10.7778 5.95385L7.47162 4.66154L5.92406 1L4.51719 4.66154Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7332 10.6556L6.62207 12.8556L12.7332 15.5445L15.1776 21.9L17.8665 15.5445L23.611 12.8556L17.8665 10.6556L15.1776 4.42224L12.7332 10.6556Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.7334 19.0787L4.37129 18.1248L5.42644 15.4222L6.58712 18.1248L9.06673 19.0787L6.58712 20.2445L5.42644 23L4.37129 20.2445L1.7334 19.0787Z",
			fill: "currentColor"
		})
	]
});
export default SvgSettlement;
